import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { OkCancel } from "lib/@components/okCancel"

export function AuthoringSelectorActions() {
    const { selectedItems } = useBoundContext()
    const totalSelected = getTotalSelected({ selectedItems })
    return (
        <OkCancel
            value={selectedItems}
            okCaption={!totalSelected ? "Add" : `Add (${totalSelected})`}
            okDisabled={() => !getTotalSelected({ selectedItems })}
        ></OkCancel>
    )
}

function getTotalSelected({ selectedItems }) {
    return selectedItems?.length
}
